<div id="dialog-content">
  <div mat-dialog-content>
    <iframe width="100%" height="100%" [src]="this.url" frameBorder="0"></iframe>
      <!-- <div id="welcome_title" class="bold">
          Thanks  for joining Wonda VR Spaces!
      </div>
    
        <div id="welcome_text">
            As you play around with the workspace, we invite you to do so through the lens of a trainer:<br>
          <ul id="items">
            <li><span class="bold">What content do you want to house into your workspace? </span><br> <i>Perhaps you already have existing 360° content, photos or videos you want to drop in </i><br></li>
            <li><span class="bold">Who do you want to invite into a live VR session?</span><br> <i>Schedule a time with 2-3 colleagues to join your live session using their VR Headset or simply using their PC and a web browser.</i><br></li>
          </ul>
            Should you have any technical questions, please feel free to reach out to us <a href="http://help.spaces.wondavr.com/" target="_blank">via our help center</a>.
            After you have finished exploring Spaces, please take 10 minutes to complete <a href="https://docs.google.com/forms/d/e/1FAIpQLSf8Y9lftAKFobn0R6tdBu09a2C1RU9ycQ7B0tzHKQzzBOb5Wg/viewform" target="_blank">our feedback form</a> .<br>
          <br>
          <div id="video-container">
              <span class="bold underline">Here is a 2’ video that we recommend you watch before you start:</span><br>
          <iframe align="middle" width="400" height="225" src="https://www.youtube.com/embed/Oydcvso1CLc" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
          <br>
          <i>The Wonda VR Team.</i>
        </div> -->
  </div>
  <div id="actions">
    <button class="button" mat-button [mat-dialog-close]="" cdkFocusInitial>Continue</button>
  </div>
</div>